import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { onPlayPause } from 'Actions';
import { isSameTrackAndPlaying } from 'Utils';
import { PlayPause, Duration, Timeline } from 'Elements';
import styles from 'partials/song-controlbar.module.scss';

export const SongControlBar = ({ song, size, color, fill }) => {
	const dispatch = useDispatch();
	const track = useSelector((state) => state.player);
	const [isRemainingTime, setIsRemaingingTime] = useState(false);

	const isPlaying = isSameTrackAndPlaying(
		track.activeTrackId,
		song.file_id,
		track.isPlaying
	);

	const dynamicProgress =
		track.progressCompleted >= 100 ? 0 : track.progressCompleted / 100;

	const toggleDuration = () => {
		setIsRemaingingTime(!isRemainingTime);
	};

	const handlePlayPause = () => {
		dispatch(onPlayPause(song));
	};

	const isSameTrack = (songId) => {
		return track.activeTrackId === songId;
	};

	return (
		<div className={styles.audioControl}>
			<PlayPause
				className={styles.audioControlPlay}
				color={color}
				fill={fill}
				size={size}
				isPlaying={isPlaying}
				onPlayPause={handlePlayPause}
			/>
			<Duration
				seconds={
					isSameTrack(song.file_id) && track.duration * dynamicProgress
				}
				className={styles.audioControlTime}
			/>
			<div className={styles.timeline}>
				<Timeline isSelected={isSameTrack(song.file_id)} />
			</div>
			{isSameTrack(song.file_id) && (
				<span
					role="button"
					tabIndex={0}
					className={styles.audioControlDuration}
					onClick={toggleDuration}
					onKeyPress={toggleDuration}>
					{isRemainingTime && (
						<Duration
							seconds={track.duration}
							className={styles.audioControlTime}
						/>
					)}
					{!isRemainingTime && (
						<Duration
							seconds={track.duration * (1 - dynamicProgress)}
							className={styles.audioControlTime}
						/>
					)}
				</span>
			)}
		</div>
	);
};

SongControlBar.propTypes = {
	color: PropTypes.string,
	fill: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

SongControlBar.defaultProps = {
	size: 22,
	color: '#505050',
	fill: '#505050'
};
